export var credentialErrors = {
    NULL: 'NULL',
    VALIDATE_FAILED: 'VALIDATE_FAILED',
    PASSWORD_FETCH_FAILED: 'PASSWORD_FETCH_FAILED',
    CREDENTIAL_EXISTS: 'CREDENTIAL_EXISTS'
};
export var credentialStatuses = {
    EMPTY: 'EMPTY',
    PROVIDER_SELECTED: 'PROVIDER_SELECTED',
    VERIFYING: 'VERIFYING',
    VERIFIED: 'VERIFIED',
    PASSWORD_FETCH_FAILED: 'PASSWORD_FETCH_FAILED',
    NOT_VERIFIED: 'NOT_VERIFIED',
    CREATED: 'CREATED',
    OK: 'OK',
    PENDING: 'PENDING',
    INCORRECT: 'INCORRECT',
    WARNING: 'WARNING',
    DELETING: 'DELETING',
    DELETING_OTHER: 'DELETING_OTHER',
    EDITABLE: 'EDITABLE'
};
